module.exports = __webpack_public_path__ + "static/important-car2-ceb2c9ec3e32c98558524b4a0397f5d3.jpg";